
export function isNavMatch(pathname: string, href: string): boolean {
  if (pathname === href) return true;
  if (href === "/") return false;
  return pathname.startsWith(href + "/");
}

export function resolveActiveHref(
  pathname: string | null | undefined,
  hrefs: readonly string[]
): string | null {
  if (!pathname) return null;
  let winner: string | null = null;
  for (const href of hrefs) {
    if (isNavMatch(pathname, href) && (winner === null || href.length > winner.length)) {
      winner = href;
    }
  }
  return winner;
}
